import LocationAppointmentPicker from './LocationAppointmentPicker';
import withInsuranceValidation from '../../../../gql/withInsuranceValidation';

export default withInsuranceValidation(LocationAppointmentPicker);
